
<mat-card class="document-picker-card" dragAndDrop (onFileDropped)="droppedFiles($event)" [class.prevent-file-drop]="!canAdd()">
  <mat-card-header class="document-picker-header mat-mdc-card-header-has-actions">
    <mat-card-title class="document-picker-title">
      Documents
    </mat-card-title>
  </mat-card-header>

  <mat-card-content class="document-picker-content">

    @if (Files() && Files().length > 0) {
      <mat-list class="document-picker-list" scrollInsetShadow>
        @for (file of Files(); track file) {
          <mat-list-item class="document-picker-item" [ngClass]="backgroundColor(file)">
            <div class="document-picker-filename" matListItemTitle>
              @if (file.CanDownload) {
                <a [href]="file.DownloadLink" target="_blank">
                  {{file.Filename}}
                </a>
              }
              @if (!file.CanDownload) {
                {{file.Filename}}
              }
            </div>
            <div class="document-picker-status" matListItemLine>
              @if (file.IsUploading) {
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              }
              @if (!file.IsUploading) {
                {{file.Status}}
              }
            </div>
            <button mat-icon-button matListItemMeta (click)="removeFile(file)" [disabled]="DisableDeleteButton()" type="button"
              aria-label="Remove document">
              <mat-icon>delete</mat-icon>
            </button>
          </mat-list-item>
        }
      </mat-list>
    } @else {
      <div class="document-picker-empty">
        <em>No files selected. Drag-and-drop files or select Browse Files.</em>
      </div>
    }

  </mat-card-content>

  <mat-divider class="document-picker-divider"></mat-divider>

  @if (!canAdd()) {
    <div class="prevent-file-drop-ui">
      No files can be added.
    </div>
  }

  <mat-card-actions class="document-picker-actions">
    <span class="document-picker-overall-status">
      {{GetOverallStatus()}}
    </span>

    <button class="document-picker-browse" mat-raised-button color="accent" (click)="hiddenfileinput.click()" [disabled]="!canAdd()" type="button">
      Browse files
    </button>
    <input type="file" multiple style="display: none;" (change)="browsedFiles($event)" [(ngModel)]="inputValue" #hiddenfileinput />

  </mat-card-actions>

</mat-card>

